import React, { useState, useEffect, useRef } from 'react';
import { Sidebar } from 'primereact/sidebar';
import FormInput from '../../../../components/Form/FormInput';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { CONSTANT } from '../../../../utils/constants';
import PropertyField from '../../../../components/Properties/PropertyField';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { Button } from 'primereact/button';

function InternalResourceManager({
  isOpen,
  resource,
  onUpdate,
  onCreate,
  emptyPayload,
  setPanelIsOpen,
  loading
}) {
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [type, setType] = useState('');
  const [publicList, setPublicList] = useState([]);
  const [city, setCity] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    if (resource) {
      setTitle(resource.title);
      setAuthor(resource.author);
      setType(resource.type);
      setPublicList(
        resource?.public_list?.filter((ot) => ot.type === 'sy_public_list').map((ot) => ot.id)
      );
      setCity(resource.city);
      setContent(resource.content);
    } else {
      setTitle('');
      setAuthor('');
      setType('');
      setPublicList([]);
      setCity('');
      setContent('');
    }
  }, [resource, emptyPayload]);

  const handleValidate = () => {
    const resourcePayload = {
      title,
      author,
      type,
      public_list: publicList,
      city,
      content
    };
    resource ? onUpdate(resourcePayload) : onCreate(resourcePayload);
  };

  const onClose = () => {
    setPanelIsOpen(false);
  };

  const formIsValid = () => {
    return title.length > 3 && type.length > 3 && content.length > 3 && publicList;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ressource`}
        loading={loading}
        disabled={!formIsValid()}
        onClick={handleValidate}
        severity="success"
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: '80vw' }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${resource ? 'Modifier' : 'Ajouter'} une Ressource Interne`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="grid grid-cols-2 gap-5 h-full overflow-y-hidden">
          <div className="flex flex-col gap-y-3 ">
            <FormInput
              key="content"
              label={'Contenu'}
              required
              isValid={content.length > 3}
              helpMessage={'Maintenez la touche Alt enfoncée pour conserver le ratio des images'}
              className="grow">
              <RichTextEditor
                value={content}
                onChange={(value) => {
                  setContent(value);
                }}
                acceptImage
                acceptHeaders
                height={'65vh'}
              />
            </FormInput>
            {footerButtons}
          </div>
          <div className="form-wrapper overflow-y-scroll h-auto">
            <FormInput key="title" label={'Titre'} required isValid={title.length > 3}>
              <InputText
                id="title"
                value={title}
                maxLength={300}
                placeholder="Veuillez saisir le titre"
                onChange={(e) => setTitle(e.target.value)}
              />
            </FormInput>
            <FormInput key="author" label={'Auteur'}>
              <InputText
                id="author"
                value={author}
                maxLength={300}
                placeholder="Veuillez saisir l'auteur"
                onChange={(e) => setAuthor(e.target.value)}
              />
            </FormInput>
            <FormInput key="type" label={'Type'} required isValid={type.length > 3}>
              <Dropdown
                value={type}
                options={CONSTANT.solarys.resourceTypes}
                optionLabel="label"
                onChange={(e) => setType(e.value)}
                placeholder="Indiquez le type de resource"
                className="grow"
              />
            </FormInput>
            <FormInput
              key="public_list"
              label={'Public cible'}
              required
              isValid={publicList.length}>
              <PropertyField
                type={'sy_public_list'}
                selectedPropertyList={publicList}
                setSelectedPropertyList={setPublicList}
                scope={'solarys'}
              />
            </FormInput>
            <FormInput key="city" label={'Ville'}>
              <Dropdown
                value={city}
                options={CONSTANT.solarys.cities}
                optionLabel="label"
                onChange={(e) => setCity(e.value)}
                placeholder="Indiquez le ville"
                className="grow"
              />
            </FormInput>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}

export default InternalResourceManager;
